import React from 'react';
import { AccountType } from './ChartOfAccounts';
interface AccountTypeBadgeProps {
  type: AccountType;
  size?: 'sm' | 'md' | 'lg';
}
export function AccountTypeBadge({
  type,
  size = 'md'
}: AccountTypeBadgeProps) {
  // Map color names to Tailwind classes
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'blue':
        return 'bg-blue-100 text-blue-800';
      case 'red':
        return 'bg-red-100 text-red-800';
      case 'green':
        return 'bg-green-100 text-green-800';
      case 'yellow':
        return 'bg-yellow-100 text-yellow-800';
      case 'purple':
        return 'bg-purple-100 text-purple-800';
      case 'pink':
        return 'bg-pink-100 text-pink-800';
      case 'indigo':
        return 'bg-indigo-100 text-indigo-800';
      case 'gray':
        return 'bg-gray-100 text-gray-800';
      case 'orange':
        return 'bg-orange-100 text-orange-800';
      case 'teal':
        return 'bg-teal-100 text-teal-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  // Size classes
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : size === 'lg' ? 'px-3 py-1 text-sm' : 'px-2.5 py-0.5 text-xs';
  const colorClasses = getColorClasses(type.color);
  return <span className={`inline-flex items-center rounded-full font-medium ${colorClasses} ${sizeClasses}`} data-id="element-6540">
      {type.name}
    </span>;
}